import { z } from "zod";
export const coverUploadResponseSchema = z.object({
    coverUrl: z.url(),
});
